import { defineComponent } from '@nuxtjs/composition-api';
import publicPortfolioUserQuery from '@/components/partials/public-portfolio/PublicPortfolioHero/apollo/PublicPortfolioHero.query';
import type { PublicPortfolioHeroData } from '@/components/partials/public-portfolio/PublicPortfolioHero/types';

export default defineComponent({
  name: 'PublicPortfolioHeroDataMixin',
  apollo: {
    publicPortfolioUser: {
      query: publicPortfolioUserQuery,
      variables(): { slug: string } {
        return {
          slug: this.$route.params.slug,
        };
      },
    },
  },
  data(): { publicPortfolioUser: PublicPortfolioHeroData } {
    return {
      publicPortfolioUser: {
        firstname: '',
        connections: {
          totalCount: 0,
        },
        configuration: {
          sectionConnectionsIsPublic: false,
        },
      },
    };
  },
  computed: {
    isCurrentUserPortfolio() {
      return this.$route.params.slug === this.$auth.user?.slug;
    },
  },
  methods: {
    refetch(): void {
      this.$apollo.queries.publicPortfolioUser.refetch();
    },
  },
});
